import { useEffect, useState } from 'react';
import { mapEmployees } from '../../../MyTask/helper/helper';
import employeeService from '../../../../services/EmployeeService';

export default function useFetchActiveEmployees() {
  const [activeEmployeesLoading, setActiveEmployeesLoading] = useState(false);
  const [activeEmployeeOptions, setActiveEmployeesOptions] = useState([]);

  useEffect(() => {
    const fetchActiveEmployees = async () => {
      try {
        setActiveEmployeesLoading(true);
        const response = await employeeService.getActiveEmployees();

        const employees = response?.data?.data || [];

        setActiveEmployeesOptions(employees.map(mapEmployees));
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.error('Error fetching active employees:', error);
      } finally {
        setActiveEmployeesLoading(false);
      }
    };
    fetchActiveEmployees();
  }, []);

  return { activeEmployeeOptions, setActiveEmployeesOptions, activeEmployeesLoading };
}
